import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const Action = ({ row, deleteCollaborator }) => {
  return (
    <div data-testid="action-cell" className="action-cell">
      <div className="details">
        <div className="cell-header">Actions</div>
        <span
          className="icon-trash icon"
          onClick={() => {
            deleteCollaborator(row.original);
          }}
          aria-hidden
        />
      </div>
    </div>
  );
};

Action.defaultProps = {};

Action.propTypes = {
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  deleteCollaborator: PropTypes.func.isRequired,
};

export default Action;
